/** Internal dependencies */
import { apiCall } from '../apiCall';
import { getCurrentFilters } from '../getCurrentFilters';
import { resetPagination } from '../resetPagination';

/**
 * Handles the reset button by deactivating all active filters.
 *
 * @author rafhun <rafhun@cubetech.ch>
 *
 * @param {Event} e
 * @returns void
 */
export function handleResetButton(e) {
    const target = e.target.closest('button');
    if (!target) {
        return;
    }

    e.preventDefault();

    const parent = target.closest('[data-ct-rest]');
    const activeFilters = parent.querySelectorAll(
        '[data-ct-filter="button"].active, [data-ct-filter="dropdown"]:checked, [data-ct-filter="nouislider"], [data-ct-filter="search"]'
    );

    if (activeFilters) {
        activeFilters.forEach((filter) => {
            switch (filter.dataset.ctFilter) {
                case 'button':
                    filter.setAttribute('aria-pressed', 'false');
                    filter.classList.remove('active');
                    break;
                case 'dropdown':
                    filter.checked = false;
                    break;
                case 'nouislider':
                    filter.noUiSlider?.reset();
                    break;
                case 'search':
                    filter.value = '';
                    break;
            }
        });

        const activeFiltersContainer = parent.querySelector('[data-ct-filters-active]');
        if (activeFiltersContainer) {
            activeFiltersContainer.textContent = '';
        }

        resetPagination(parent);
        const currentFilters = getCurrentFilters(parent);
        apiCall(parent, currentFilters, true);
    }
}
